// extracted by mini-css-extract-plugin
module.exports = {"category":"Category_category__32Ody","text_dark":"Category_text_dark__1mZfh","text_light":"Category_text_light__ry8Ql","selected":"Category_selected__22HCO"};